var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"LayoutCenter",attrs:{"mb-5":""}},[_c('v-col',{attrs:{"cols":"12","md":"8","offset-md":"2"}},[_c('v-div',{attrs:{"float-center":"","width-100-percent":"","max-width-720":"","text-center":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }